
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/snackbar",
      function () {
        return require("private-next-pages/joy-ui/api/snackbar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/snackbar"])
      });
    }
  